export default __webpack_public_path__ + "static/media/uniform.bfc12b9b.jpg";